import { render, staticRenderFns } from "./ReleaseInspectorView.vue?vue&type=template&id=d56e6a6a&scoped=true&"
import script from "./ReleaseInspectorView.vue?vue&type=script&lang=js&"
export * from "./ReleaseInspectorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56e6a6a",
  null
  
)

export default component.exports